<h2>AGB</h2>

<p>
  Bitte lesen Sie die Allgemeinen Geschäftsbedingungen (AGB) und Datenschutzbestimmungen.
</p>

<form id="agbForm" #f="ngForm">

  <textarea readonly style="width: 100%; height: 40em; font-size: 12px">{{agbText}}</textarea>

  <p>
    <input id="agbAccepted" name="agbAccepted" type="checkbox" required [(ngModel)]="organization.agbAccepted"/>
    <label for="agbAccepted">Ich habe die Allgemeinen Geschäftsbedingungen (AGB) und Datenschutzbestimmungen gelesen, verstanden und akzeptiere sie.</label>
  </p>

  <p>
    Die ausdrückliche Anerkennung unserer AGB und Datenschutzbestimmungen ist Voraussetzung für die Lizenzerteilung.
  </p>

</form>

<div class="buttonRow">
  <button (click)="appController.previous()">Zurück</button>
  <button (click)="appController.next(f)">Weiter</button>
</div>
